import {HudNavItem, IconComponent} from 'widgets/hud/model/routes.ts';
import {Support} from 'shared/ui/icons/hudIcons/support.tsx';
import {BookIcon, GrantIcon, PaletteIcon} from 'shared/ui/icons';
import {WorldIcon} from 'shared/ui/icons/world-icon.tsx';

export const SUPPORT_BTN: HudNavItem = {
  id: 'support',
  label: 'Поддержка',
  icon: Support as IconComponent,
  iconActive: Support as IconComponent,
  isClickable: true,
  iconActiveFill: 'rgba(255, 79, 18, 1)',
};

export const SETTINGS_BUTTONS: HudNavItem[] = [
  {
    id: 'timezoneSettings',
    label: 'Часовой пояс',
    icon: WorldIcon as IconComponent,
    iconActive: WorldIcon as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'themeSettings',
    label: 'Тема оформления',
    icon: PaletteIcon as IconComponent,
    iconActive: PaletteIcon as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'dictionarySettings',
    label: 'Словари',
    icon: BookIcon as IconComponent,
    iconActive: BookIcon as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'vetisSection',
    label: 'Интеграция с ФГИС',
    icon: GrantIcon as IconComponent,
    iconActive: GrantIcon as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
];
